import React from 'react';
import PropTypes from 'prop-types';

function ChevronDown({ size = 20, color, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path className={`icon-chevron-down`} d="M4 7L10 13L16 7" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

ChevronDown.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.number,
  className: PropTypes.string
}

export default ChevronDown;
